import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#243565',
      light: '#e9f0fd',
      dark: '#243565'
    },
    secondary: {
      main: '#32B2A6',
      light: '#DAF5F2'
    },
    error: {
      main: '#bf0000'
    },
    action: {
      disabledBackground: '#D3D7E0',
      disabled: '#fff'
    }
  }
});

export default theme;
